<template>
    <div class="hiq-event-view__info--relatedEvent">
        <a :href="event.url" :title="event.title" :style="accentColor" class="hiq-event-view__info--relatedEvent__link">
            <div :style="accentBackgroundColor" class="hiq-event-view__info--relatedEvent__dates">{{getDates(event.start, event.end)}}</div>
            <div>
                <div :style="textColor" class="hiq-event-view__info--relatedEvent__title">
                    {{event.title}}
                </div>
                <div class="hiq-event-view__info--relatedEvent__info">
                    <span :style="textColor" class="hiq-event-view__info--relatedEvent__time">{{getTime(event.start)}}<span :style="accentColor" aria-hidden="true" class="hiq-event-view__info--relatedEvent__time--icon"></span></span>
                    <span :style="textColor" class="hiq-event-view__info--relatedEvent__location">{{event.location}}<span :style="accentColor" aria-hidden="true" class="hiq-event-view__info--relatedEvent__location--icon"></span></span>
                </div>             
            </div>        
        </a>
    </div>
</template>

<script>
import moment from 'moment';

var locale = document.documentElement.lang;
moment.locale(locale);
export default {
    name: 'OtherOccasion',
    props: {
        event: {},
    },
    computed: {
        textColor() { return this.$store.getters.textColor; },
        accentColor() { return this.$store.getters.accentColor; },
        accentBackgroundColor() { 
            var styleString = this.$store.getters.accentBackgroundColor;
            if(this.$store.state.isVisitSite){
                styleString += ' color: #FFFFFF';
            } else {
                styleString += ' color: #000';
            }
            return styleString; 
        }
    },
    methods: {
        getDates(start, end){
            var formattedDate = '';
            var startDate = moment(start);
            var endDate = moment(end);
            formattedDate = startDate.format('DD MMM');
            if(!startDate.isSame(endDate, 'day')){
                formattedDate += ' - ' + endDate.format('DD MMM');
            }
            return formattedDate;
        },
        getTime(start){
            return moment(start).format('HH.mm');
        }
    }
}
</script>